import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Popover,
  message,
  Tabs,
  Input,
  DatePicker,
  Table,
  Upload
} from "antd";
import { withRouter } from "react-router-dom";
import { UploadOutlined, SendOutlined, ShareAltOutlined } from "@ant-design/icons";
import InvitationHeader from "./InvitationHeader/InvitationHeader";
import StageSuccess from "../../svg/svgicon/StageIcon/StageSuccess";
import ButtonStage from "../../Components/MyComponent/ButtonStage";
import EvaluationMember from "./EvaluationMember/EvaluationMember";
import DocumentList from "./Documents/DocumentList";
import CriteriaList from "./Criteria/CriteriaList";
// import RequiredList from "./Required/RequiredList";
// import CreateInvitation from "./CreateInvitation/CreateInvitation";
import StakeHolder from "./StakeHolders/StakeHolder";
import FolderCaseList from "./FolderCase/FolderCaseList";
import NoteList from "./Notes/NoteList";
import PopConfirm from "../../Components/MyComponent/PopConfirm";
import { API } from "../../../src/API/API";
import UserContext from "../UserContext/UserContext";
import PrintComponent from "../../Components/PrintComponent/PrintComponent";
import InvitationToPDF from "./InvitationToPDF/InvitationToPDF";
import { baseConfig } from "../../Config/Config";
import getBase64 from "../../Components/ConvertBase64/getBase64";

const { TabPane } = Tabs;
const { TextArea } = Input;
const dateFormat = "YYYY.MM.DD HH:mm";
const delayedCols = [
  {
    title: "Хойшлуулсан хэрэглэгч",
    dataIndex: "delayedby",
    key: "delayedby",
    width: "25%",
    align: "left",
  },
  {
    title: "Тайлбар",
    dataIndex: "delayednote",
    key: "delayednote",
    width: "25%",
    align: "left",
  },
  {
    title: "Хүлээн авах эцсийн огноо",
    dataIndex: "acceptdate",
    key: "acceptdate",
    width: "25%",
    align: "left",
  },
  {
    title: "Тендер нээх огноо",
    dataIndex: "opendate",
    key: "opendate",
    width: "25%",
    align: "left",
  },
];
var moment = require("moment");

class Invitation extends Component {

  static contextType = UserContext;
  // formRef = React.createRef();
  // constructor(props) {
  //   super(props);
    state = {
       invitationid: this.props.match.params.invitationid,
        invitationcode: "",
        tenderid: this.props.match.params.tenderid,
        tendername: this.props.match.params.tendername,
        department: this.props.match.params.department,
        typename: this.props.match.params.typename,
        purchasemethod: this.props.match.params.purchasemethod,
        budget: this.props.match.params.budget,
        acceptdate: null,
        opendate: null,
        publishdate: null,
        description: "",
        isEdit: this.props.match.params.isedit,
        stage: 1,
        popConfirmVisible: false,
        popConfirmRequestVisible: false,
        popConfirmRePublishVisible: false,
        popConfirmRePublishReqVisible: false,
        pdfData: [],
        delayedList: [],
        status: 0,
        statusname: null,
        filename: "",
        filedata: null,
        filelist: [],
        dkey: 1,
    };    
  //}
  
  componentDidMount = () => {
    this.getData();
    this.onChangePopConfirmVisible();
  };
  getData = () => {
    API.get("/saveInvitationHeader?tenderid=" +
      this.state.tenderid + "&createdby=" + this.context.username +
      "&invitationid=" + this.state.invitationid
    ).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        if (response.data.retData.length > 0) {
          this.setState((prevState) => ({
            invitationid: response.data.retData[0][0].invitationid,
            acceptdate: response.data.retData[0][0].acceptdate,
            opendate: response.data.retData[0][0].opendate,
            publishdate: response.data.retData[0][0].publishdate,
            description: response.data.retData[0][0].description,
            invitationcode: response.data.retData[0][0].invitationcode,
            status: response.data.retData[0][0].status,
            statusname: response.data.retData[0][0].statusname,
            delayedList: response.data.retData[1],
            dkey: prevState.dkey + 1,
          }));
        }
      }
    });

    //this.getPdfData();
  };
  // getPdfData = () => {
  //   API.get(
  //     "/getInvitationToPdf?tenderid=" +
  //       this.state.tenderid +
  //       "&invitationid=" +
  //       this.state.invitationid
  //   ).then((response) => {
  //     if (response.status === 200 && response.data.retType === 0) {
  //       this.setState({
  //         pdfData: response.data.retData
  //       });
  //     }
  //   });
  // };
  onChangeAcceptDate = (value) => {
    this.setState({ acceptdate: value });
  };
  onChangeOpenDate = (value) => {
    this.setState({ opendate: value });
  };
  onChangePublishDate = (value) => {
    this.setState({ publishdate: value });
  };
  onChangeDescription = (e) => {
    this.setState({ description: e.target.value });
  };
  onChangeStage = (e) => {
    // if (e != 0) {
    if (e !== 0) {  
      this.setState({ stage: e });
    } else {
      let stage = this.state.stage;
      this.setState({ stage: stage + 1 });
    }
    if (e === 6) {
      //this.getPdfData();
    }
  };
  //#region Publish
  onChangePopConfirmVisible = (visible) => {
    this.setState({ popConfirmVisible: visible });    
  };
  popConfirm = () => {
    return (
      <PopConfirm
        question="Та тендерийн урилгыг вэб сайт дээр нийтлэх гэж байна. Итгэлтэй байнуу?"
        onClickYes={this.onPublishInvitation}
        onClickNo={() => {
          this.onChangePopConfirmVisible(false);
        }}
      />
    );
  };
 
  //#endregion
  //#region RePublishRequest
  popConfirmRePublishRequest = () => {
    return (
      <PopConfirm
        question="Та тендерийн урилгыг дахин зарлах хүсэлт илгээх гэж байна. Итгэлтэй байнуу?"
        onClickYes={this.onRePublishRequestInvitation}
        onClickNo={() => this.onChangePopConfirmRePublishReqVisible(false)}
      />
    );
  };
  onChangePopConfirmRePublishReqVisible = (visible) => {
    this.setState({ popConfirmRePublishReqVisible: visible });
  };
  onRePublishRequestInvitation = () => {
    this.setState({ popConfirmRePublishReqVisible: false });
    let body = {
      url: baseConfig.makurl,
      session_id: localStorage.getItem("access_token"),
      invitationid: this.state.invitationid,
      tendername: this.state.tendername
    }
    API.post("/rePublishRequestInv", body).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        message.success("Урилга дахин зарлах хүсэлт амжилттай илгээгдлээ.");
        this.getData();
      }
    });
  }
  //#endregion
  //#region RePublish
  popConfirmRePublish = () => {
    return (
      <PopConfirm
        question="Та тендерийн урилгыг дахин зарлах гэж байна. Итгэлтэй байнуу?"
        onClickYes={this.onRePublishInvitation}
        onClickNo={() => this.onChangePopConfirmRePublishVisible(false)}
      />
    );
  };
  onRePublishInvitation = () => {
    let body = {
      invitationid: this.state.invitationid,
      tenderid: this.state.tenderid,
      createdby: this.context.username
    }
    API.post("/rePublishInvitation", body).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        message.success("Урилга амжилттай дахин зарлагдлаа.");
        this.props.history.push("/tender/2");
      }
    });
  }
  onChangePopConfirmRePublishVisible = (visible) => {
    this.setState({ popConfirmRePublishVisible: visible });
  };
  //#endregion
  //#region PublishRequest
  popConfirmRequest = () => {
    return (
      <PopConfirm
        question="Та тендерийн урилгыг баталгаажуулах хүсэлтийг и-мэйлээр илгээх гэж байна. Итгэлтэй байнуу?"
        onClickYes={this.onPublishRequestInvitation}
        onClickNo={() => this.onChangePopConfirmRequestVisible(false)}
      />
    );
  };
  onChangePopConfirmRequestVisible = (visible) => {
    this.setState({ popConfirmRequestVisible: visible });
  };
  onPublishInvitation = () => {
    let iError = false;
    let warning = "";
    if (!this.state.acceptdate) {
      iError = true;
      warning = "'Тендер хүлээн авах эцсийн хугацаа' ";
    }
    if (!this.state.opendate) {
      iError = true;
      warning = warning + "'Тендер нээх хугацаа' ";
    }
    if (!this.state.description) {
      iError = true;
      warning = warning + "'Дэлгэрэнгүй тайлбар' ";
    }
    if (iError === false) {
      API.get(
        "/getInvitationToPdf?tenderid=" +
        this.state.tenderid +
        "&invitationid=" +
        this.state.invitationid
      ).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          if (!response.data.retData[1].length > 0) {
            iError = true;
            warning = "'Шалгуур үзүүлэлт' ";
          }
          // if (!response.data.retData[2].length > 0) {
          //   iError = true;
          //   warning = "'Бүрдүүлэх материал' ";
          // }
          if (!response.data.retData[3].length > 0) {
            iError = true;
            warning = "'Материал хүлээн авах мэдээлэл' ";
          }
          if (!response.data.retData[4].length > 0) {
            iError = true;
            warning = "'Бичиг баримт' ";
          }
          if (iError === false) {
            if (moment(this.state.opendate, dateFormat) < moment(new Date(), dateFormat)) {

            }
            let body = {
              tenderid: this.state.tenderid,
              invitationid: this.state.invitationid,
              acceptdate: this.state.acceptdate,
              opendate: this.state.opendate,
              publishdate: this.state.publishdate,
              description: this.state.description,
              status: 1,
            };
            
            API.post("/saveInvitation", body).then((response) => {
              if (response.status === 200 && response.data.retType === 0) {
                if (this.state.status === 0) {
                  message.success("Баталгаажуулах хүсэлт илгээгдлээ.");
                  this.setState({ status: 6 });
                  this.props.history.push("/tender/2");
                } else {
                  message.success("Урилга амжилттай нийтлэгдлээ.");
                  this.setState({ status: 1 });
                  this.props.history.push("/tender/3");
                }
                this.setState({
                  popConfirmVisible: false,
                  popConfirmRequestVisible: false,
                });
              }
            });
          } else {
            message.warning(warning + "үе шат дээр утга оруулна уу.");
          }
        }
      });
      // }
      // else{
      //   message.warning("Хүлээн авах эцсийн хугацаа тендер нээх хугацаанаас хойш байж болохгүй.")
      // }
    } else {
      message.warning(warning + "талбарт утга оруулна уу.");
    }
  };
  onPublishRequestInvitation = async () => {
    let iError = false;
    let warning = "";
    if (!this.state.acceptdate) {
      iError = true;
      warning = "'Тендер хүлээн авах эцсийн хугацаа' ";
    }
    if (!this.state.opendate) {
      iError = true;
      warning = warning + "'Тендер нээх хугацаа' ";
    }
    if (!this.state.description) {
      iError = true;
      warning = warning + "'Дэлгэрэнгүй тайлбар' ";
    }
    if (iError === false) {
      API.get(
        "/getInvitationToPdf?tenderid=" +
        this.state.tenderid +
        "&invitationid=" +
        this.state.invitationid
      ).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          if (!response.data.retData[1].length > 0) {
            iError = true;
            warning = "'Шалгуур үзүүлэлт' ";
          }
          // if (!response.data.retData[2].length > 0) {
          //   iError = true;
          //   warning = "'Бүрдүүлэх материал' ";
          // }
          if (!response.data.retData[3].length > 0) {
            iError = true;
            warning = "'Материал хүлээн авах мэдээлэл' ";
          }
          if (!response.data.retData[4].length > 0) {
            iError = true;
            warning = "'Бичиг баримт' ";
          }
          if (iError === false) {
            if (moment(this.state.opendate, dateFormat) < moment(new Date(), dateFormat)) {

            }
            let body = {
              tenderid: this.state.tenderid,
              invitationid: this.state.invitationid,
              acceptdate: this.state.acceptdate,
              opendate: this.state.opendate,
              publishdate: this.state.publishdate,
              description: this.state.description,
              status: 6,
            };
            API.post("/saveInvitation", body).then((response) => {
              if (response.status === 200 && response.data.retType === 0) {
                let filename = "";
                let extension = "";
                let base64Data = "";
                let body = null;
                if (this.state.filedata) {
                  getBase64(this.state.filedata.originFileObj)
                    .then(result => {
                      filename = this.state.filename.split('.').slice(0, -1).join('.');
                      extension = this.state.filename.split(".").pop();
                      base64Data = result.split("base64,").pop();
                      body = {
                        url: baseConfig.makurl,
                        session_id: localStorage.getItem("access_token"),
                        invitationid: this.state.invitationid,
                        tendername: this.state.tendername,
                        attachment: {
                          filename: filename,
                          extension: extension,
                          data: base64Data
                        },
                      };

                      API.post("/publishRequestInv", body).then((response) => {
                        if (response.status === 200 && response.data.retType === 0) {
                          message.success("Баталгаажуулах хүсэлт илгээгдлээ.");
                          this.setState({ status: 6 });
                          this.props.history.push("/tender/2");
                          this.setState({
                            popConfirmVisible: false,
                            popConfirmRequestVisible: false,
                          });
                        }
                      });
                    });
                }
                else {
                  body = {
                    url: baseConfig.makurl,
                    session_id: localStorage.getItem("access_token"),
                    invitationid: this.state.invitationid,
                    tendername: this.state.tendername,
                    attachment: {
                      filename: "",
                      extension: "",
                      data: ""
                    },
                  };

                  API.post("/publishRequestInv", body).then((response) => {
                    if (response.status === 200 && response.data.retType === 0) {
                      message.success("Баталгаажуулах хүсэлт илгээгдлээ.");
                      this.setState({ status: 6 });
                      this.props.history.push("/tender/2");
                      this.setState({
                        popConfirmVisible: false,
                        popConfirmRequestVisible: false,
                      });
                    }
                  });
                };
              }
            });
          } else {
            message.warning(warning + "үе шат дээр утга оруулна уу.");
          }
        }
      });
      // }
      // else{
      //   message.warning("Хүлээн авах эцсийн хугацаа тендер нээх хугацаанаас хойш байж болохгүй.")
      // }
    } else {
      message.warning(warning + "талбарт утга оруулна уу.");
    }
  };
  //#endregion
  onSaveInvitation = async () => {
    //await this.getPdfData();
    if (this.state.acceptdate && this.state.opendate) {
      if (this.state.description) {
        let body = {
          tenderid: this.state.tenderid,
          invitationid: this.state.invitationid,
          acceptdate: this.state.acceptdate,
          opendate: this.state.opendate,
          publishdate: this.state.publishdate,
          description: this.state.description,
          status: this.state.status === 6 ? 6 : this.state.status === 1 ? 1 : 0,
        };
        API.post("/saveInvitation", body).then((response) => {
          if (response.status === 200 && response.data.retType === 0) {
            message.success("Урилга амжилттай хадгалагдлаа.");
            this.getData();
          }
        });
      }
      else {
        message.warning("Дэлгэрэнгүй тайлбар оруулна уу.");
      }
    }
    else {
      message.warning("Огноо оруулна уу.");
    }
  };
  onSaveInvitationAfterPublish = () => {
    //this.getPdfData();
    let body = {
      tenderid: this.state.tenderid,
      invitationid: this.state.invitationid,
      acceptdate: this.state.acceptdate,
      opendate: this.state.opendate,
      publishdate: this.state.publishdate,
      description: this.state.description,
      status: 0,
    };
    API.post("/saveInvitation", body).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        message.success("Урилга амжилттай хадгалагдлаа.");
        this.props.history.push("/tender/2");
      }
    });
  };
  fileOnChange = (info) => {
    this.setState({
      filelist: info.fileList,
      filedata: info.file,
      filename: info.file.name,
    });
  };


  // test bulk notification email:
  sendMassMail = () => {
    let body = {
      url: baseConfig.makurl,
     
      invitationid: this.state.invitationid,
      tendername: this.state.tendername,
      acceptdate: this.state.acceptdate,
      description: this.state.description
    }
    API.post("/sendNewTenderNotification", body).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        message.success("Имэйл амжилттай илгээгдсэн.");
        this.setState({ status: 1 });       
      }
    });
  };  
  

  render() {
    console.log("this states=" + this.state.isEdit);
    console.log("this.state.status=", this.state.status);
    console.log("edit=",this.state.isEdit)
    return (
      <div key={this.state.dkey}>
        <div style={{ backgroundColor: "white" }}>
          <InvitationHeader
            title={
              this.props.match.params.opening === "true" ? "Нээлт" : "Урилга"
            }
            tendername={this.state.tendername}
            department={this.state.department}
            typename={this.state.typename}
            purchasemethod={this.state.purchasemethod}
            budget={this.state.budget}
            statusname={this.state.statusname}
            status={this.state.status}
          />
        </div>
        {this.state.isEdit === "1" ? (
          <div>
            <div style={{ backgroundColor: "white" }}>
              <div className="mainContainer">
                <Row gutter={(16, 16)} justify="start" align="middle">
                  <Col span={2.1}>
                    <Row justify="start" align="middle">
                      <Col>
                        <div className="stageCircle">
                          <ButtonStage
                            onClick={() => this.onChangeStage(1)}
                            value={
                              this.state.stage === 1 ? 1 : <StageSuccess />
                            }
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="stageLabel">Үнэлгээний хороо</div>
                      </Col>
                    </Row>
                  </Col>
                  <Col style={{ marginLeft: -10, marginTop: 3 }} span={2}>
                    <div
                      className="stageBorder"
                      style={{
                        borderColor:
                          this.state.stage > 1 ? "#0358A7" : "#E5E5E5",
                      }}
                    ></div>
                  </Col>
                  <Col style={{ marginLeft: -15 }} span={2.1}>
                    <Row justify="start" align="middle">
                      <Col>
                        <div className="stageCircle">
                          <ButtonStage
                            onClick={() => this.onChangeStage(2)}
                            value={this.state.stage > 2 ? <StageSuccess /> : 2}
                            disabled={this.state.stage < 2 ? true : false}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="stageLabel">Тендерийн бичиг,баримт</div>
                      </Col>
                    </Row>
                  </Col>
                  <Col style={{ marginLeft: -10, marginTop: 3 }} span={2}>
                    <div
                      className="stageBorder"
                      style={{
                        borderColor:
                          this.state.stage > 2 ? "#0358A7" : "#E5E5E5",
                      }}
                    ></div>
                  </Col>
                  <Col style={{ marginLeft: -15 }} span={2.1}>
                    <Row justify="start" align="middle">
                      <Col>
                        <div className="stageCircle">
                          <ButtonStage
                            onClick={() => this.onChangeStage(3)}
                            value={this.state.stage > 3 ? <StageSuccess /> : 3}
                            disabled={this.state.stage < 3 ? true : false}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="stageLabel">Шалгуур үзүүлэлт</div>
                      </Col>
                    </Row>
                  </Col>
                  <Col style={{ marginLeft: -10, marginTop: 3 }} span={2}>
                    <div
                      className="stageBorder"
                      style={{
                        borderColor:
                          this.state.stage > 3 ? "#0358A7" : "#E5E5E5",
                      }}
                    ></div>
                  </Col>
                  {/* <Col style={{ marginLeft: -15 }} span={2.1}>
                    <Row justify="start" align="middle">
                      <Col>
                        <div className="stageCircle">
                          <ButtonStage
                            onClick={() => this.onChangeStage(4)}
                            value={this.state.stage > 4 ? <StageSuccess /> : 4}
                            disabled={this.state.stage < 4 ? true : false}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="stageLabel">Бүрдүүлэх материал</div>
                      </Col>
                    </Row>
                  </Col>
                  <Col style={{ marginLeft: -10, marginTop: 3 }} span={2}>
                    <div
                      className="stageBorder"
                      style={{
                        borderColor:
                          this.state.stage > 4 ? "#0358A7" : "#E5E5E5",
                      }}
                    ></div>
                  </Col> */}
                  <Col style={{ marginLeft: -15 }} span={2.1}>
                    <Row justify="start" align="middle">
                      <Col>
                        <div className="stageCircle">
                          <ButtonStage
                            onClick={() => this.onChangeStage(4)}
                            value={this.state.stage > 4 ? <StageSuccess /> : 4}
                            disabled={this.state.stage < 4 ? true : false}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="stageLabel">Материал хүлээн авах мэдээлэл</div>
                      </Col>
                    </Row>
                  </Col>
                  <Col style={{ marginLeft: -10, marginTop: 3 }} span={2}>
                    <div
                      className="stageBorder"
                      style={{
                        borderColor:
                          this.state.stage > 4 ? "#0358A7" : "#E5E5E5",
                      }}
                    ></div>
                  </Col>
                  <Col style={{ marginLeft: -15 }} span={2.1}>
                    <Row justify="start" align="middle">
                      <Col>
                        <div className="stageCircle">
                          <ButtonStage
                            onClick={() => this.onChangeStage(5)}
                            value={this.state.stage > 5 ? <StageSuccess /> : 5}
                            disabled={this.state.stage < 5 ? true : false}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="stageLabel">Урилга</div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="mainContainer">
              {this.state.stage === 1 ? (
                <EvaluationMember
                  isEdit={true}
                  invitationid={this.state.invitationid}
                  tendername={this.state.tendername}
                />
              )
                : this.state.stage === 2 ? (
                  <DocumentList
                    invitationid={this.state.invitationid}
                    isEdit={true}
                  />
                ) : this.state.stage === 3 ? (
                  <CriteriaList
                    invitationid={this.state.invitationid}
                    isEdit={true}
                  />
                ) : this.state.stage === 4 ? (
                  <NoteList
                    invitationid={this.state.invitationid}
                    isEdit={true}
                  />
                ) : this.state.stage === 5 ? (
                  <div className="Container">
                    <Row style={{ height: 56 }} justify="start" align="middle">
                      <Col>
                        <div className="HeaderLabel">5. Урилга</div>
                      </Col>
                    </Row>
                    <Row justify="end" align="middle">
                      <Col style={{ marginTop: -70 }}>
                        <PrintComponent
                          buttonText="Урилга татах"
                          content={<InvitationToPDF invitationid={this.state.invitationid} tendername={this.state.tendername} />}
                        />
                      </Col>
                    </Row>
                    <div style={{ marginTop: 20, paddingRight: 100 }}>
                      <Row gutter={[16, 16]}>
                        <Col span={6}>
                          <div className="Label" style={{ marginBottom: 5 }}>
                            Урилгийн дугаар
                          </div>
                          <Input
                            defaultValue={this.state.invitationcode}
                            size="middle"
                            disabled
                          />
                        </Col>
                        <Col span={6}>
                          <div className="Label" style={{ marginBottom: 5 }}>
                            Тендер хүлээн авах эцсийн хугацаа
                          </div>
                          <DatePicker
                            defaultValue={
                              this.state.acceptdate
                                ? moment(this.state.acceptdate, dateFormat)
                                : null
                            }
                            onChange={this.onChangeAcceptDate}
                            format={dateFormat}
                            size="middle"
                            style={{ width: "100%" }}
                            placeholder=""
                            showTime={true}
                            disabled={false}
                          ></DatePicker>
                        </Col>
                        <Col span={6}>
                          <div className="Label" style={{ marginBottom: 5 }}>
                            Тендер нээх хугацаа
                          </div>
                          <DatePicker
                            defaultValue={
                              this.state.opendate
                                ? moment(this.state.opendate, dateFormat)
                                : null
                            }
                            onChange={this.onChangeOpenDate}
                            size="middle"
                            format={dateFormat}
                            style={{ width: "100%" }}
                            placeholder=""
                            showTime={true}
                            disabled={false}
                          ></DatePicker>
                        </Col>
                        <Col span={6}>
                          <div className="Label" style={{ marginBottom: 5 }}>
                            Тендерийн урилга нийтлэх огноо
                          </div>
                          <DatePicker
                            defaultValue={
                              this.state.publishdate
                                ? moment(this.state.publishdate, "YYYY.MM.DD")
                                : null
                            }
                            onChange={this.onChangePublishDate}
                            format="YYYY.MM.DD"
                            size="middle"
                            style={{ width: "100%" }}
                            placeholder=""
                            disabled={false}
                          ></DatePicker>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 30 }} gutter={(16, 16)}>
                        <Col span={24}>
                          <div className="Label" style={{ marginBottom: 5 }}>
                            Дэлгэрэнгүй тайлбар
                          </div>
                          <TextArea
                            rows={6}
                            defaultValue={this.state.description}
                            onChange={this.onChangeDescription}
                            disabled={false}
                          />
                        </Col>
                      </Row>
                    </div>
                    {this.state.delayedList.length > 0 ?
                      <div style={{ marginTop: 20, backgroundColor: "white" }} id="tender-list">
                        <div className="MidLabel" style={{ padding: 10 }}>Хойшлуулсан түүх</div>
                        <Table
                          dataSource={this.state.delayedList}
                          columns={[
                            {
                              title: "№",
                              dataIndex: "key",
                              key: "key",
                              width: "3%",
                              render: (text, row, index) => (
                                <>{this.state.delayedList.indexOf(row) + 1}</>
                              ),
                            },
                            ...delayedCols,
                          ]}
                          pagination={false}
                          rowKey="id"
                          scroll={{ y: 340 }}
                        />
                      </div> : null}
                  </div>
                ) : null}
              {/* {this.state.stage === 5 ? ( */}
              { this.context.permission.isAdmin === "1" ?
              <Row justify="start" align="middle">
                {this.state.status === 0 ?
                  <Col>
                    <Button
                      // disabled={this.state.status !== 0 ? true : false}
                      type="primary"
                      className="btnPrimary"
                      style={{
                        marginRight: 10,
                      }}
                      onClick={this.onSaveInvitation}
                    >
                      Хадгалах
                    </Button>
                  </Col> : null}
                <Col>
                  <Popover
                    placement="bottomRight"
                    title="Санамж"
                    content={this.popConfirmRequest}
                    trigger="click"
                    visible={this.state.popConfirmRequestVisible}
                  >
                    <Button
                      // disabled={
                      //   (this.state.status !== 0) 
                      //     ? true
                      //     : false
                      // }
                      type="primary"
                      className="btnPrimary"
                      style={{
                        marginRight: 10,
                      }}
                      htmlType="submit"
                      onClick={() =>this.onChangePopConfirmRequestVisible(true)}
                      icon={<SendOutlined />}
                    >
                      Хүсэлт илгээх
                    </Button>
                  </Popover>
                </Col>
                <Col>
                  <Upload
                    style={{ width: "100%" }}
                    accept="*"
                    openFileDialogOnClick
                    onChange={this.fileOnChange}
                    showUploadList={false}
                    fileList={this.state.filelist}
                  >
                    <Button style={{ color: "black", borderColor: "#cecece", marginRight: 10 }}>
                      <Row align="middle" justify="space-between">
                        <Col>Файл хавсаргах</Col>
                        <Col style={{ marginLeft: 10, marginRight: 10 }}>
                          <UploadOutlined />
                        </Col>
                      </Row>
                      <Row>
                        <Col>{this.state.filename}</Col>
                      </Row>
                    </Button>
                  </Upload>
                </Col>
                <Col>
                  <Popover
                    placement="bottomRight"
                    title="Санамж"
                    content={this.popConfirm}
                    trigger="click"
                    visible={this.state.popConfirmVisible}
                  >
                    <Button
                      disabled={
                        (this.state.status === 6 || this.state.status === 8) 
                          ? false
                          : true
                      }
                      type="primary"
                      className="btnPrimary"
                      style={{
                        marginRight: 10,
                      }}
                      htmlType="submit"
                      onClick={() => this.onChangePopConfirmVisible(true)}
                      icon={<ShareAltOutlined />}
>
                      Урилга нийтлэх
                    </Button>
                  </Popover>
                </Col>
              </Row> : null }
              <Row justify="start" align="middle">
                <Col style={{marginTop:10}}>
                  <Button type="primary" className="btnPrimary" htmlType="submit"
                    onClick={() => this.onChangeStage(0)}>Дараагийн алхам
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <div style={{ backgroundColor: "white" }}>
            <div className="mainContainer">
              <Tabs defaultActiveKey="1">
                {this.props.match.params.opening === "true" ? (
                <TabPane tab="Оролцогч компаниуд" key="1">
                  <StakeHolder
                    status={this.state.status}
                    opendate={this.state.opendate}
                    invitationid={this.state.invitationid}
                    tendername={this.state.tendername}
                  />
                </TabPane>
                ) : null} 
                {this.props.match.params.opening === "true" ? (
                  <TabPane tab="Хавтаст хэрэг" key="2">
                    <FolderCaseList invitationid={this.state.invitationid} />
                  </TabPane>
                ) : null}
                <TabPane tab="Үнэлгээний хороо" key="3">
                  <EvaluationMember
                    status={this.state.status}
                    invitationid={this.state.invitationid}
                    isEdit={this.state.status === 7 || this.state.status === 8 ? false : true}
                    tendername={this.state.tendername}
                  />
                </TabPane>
                <TabPane tab="Тендерийн бичиг баримт" key="4">
                  <DocumentList
                    invitationid={this.state.invitationid}
                    isEdit={this.state.status === 7 || this.state.status === 8 ? false : true}
                  />
                </TabPane>
                <TabPane tab="Шалгуур үзүүлэлт" key="5">
                  <CriteriaList
                    invitationid={this.state.invitationid}
                    isEdit={this.state.status === 7 || this.state.status === 8 ? false : true}
                  />
                </TabPane>
                <TabPane tab="Материал хүлээн авах мэдээлэл" key="6">
                  <NoteList
                    invitationid={this.state.invitationid}
                    isEdit={this.state.status === 7 || this.state.status === 8 ? false : true}
                  />
                </TabPane>
                {/* <TabPane tab="Бүрдүүлэх материал" key="6">
                  <RequiredList
                    invitationid={this.state.invitationid}
                    isEdit={false}
                  />
                </TabPane> */}
                <TabPane tab="Урилга" key="7">
                  <div className="Container">
                    <Row style={{ height: 56 }} justify="start" align="middle">
                      <Col>
                        <div className="HeaderLabel">5. Урилга</div>
                      </Col>
                    </Row>
                    <Row justify="end" align="middle">
                      <Col style={{ marginTop: -70 }}>
                        <PrintComponent
                          buttonText="Урилга татах"
                          content={
                            <InvitationToPDF tendername={this.state.tendername} invitationid={this.state.invitationid} />
                          }
                        />
                      </Col>
                    </Row>
                    <div style={{ marginTop: 20, paddingRight: 100 }}>
                      <Row gutter={[16, 16]}>
                        <Col span={6}>
                          <div className="Label" style={{ marginBottom: 5 }}>
                            Урилгын дугаар
                          </div>
                          <Input
                            defaultValue={this.state.invitationcode}
                            size="middle"
                          // disabled
                          />
                        </Col>
                        <Col span={6}>
                          <div className="Label" style={{ marginBottom: 5 }}>
                            Тендер хүлээн авах эцсийн хугацаа
                          </div>
                          <DatePicker
                            defaultValue={
                              this.state.acceptdate
                                ? moment(this.state.acceptdate, dateFormat)
                                : null
                            }
                            onChange={this.onChangeAcceptDate}
                            format={dateFormat}
                            size="middle"
                            style={{ width: "100%" }}
                            placeholder=""
                            showTime={true}
                          // disabled={true}
                          ></DatePicker>
                        </Col>
                        <Col span={6}>
                          <div className="Label" style={{ marginBottom: 5 }}>
                            Тендер нээх хугацаа
                          </div>
                          <DatePicker
                            defaultValue={
                              this.state.opendate
                                ? moment(this.state.opendate, dateFormat)
                                : null
                            }
                            onChange={this.onChangeOpenDate}
                            size="middle"
                            format={dateFormat}
                            style={{ width: "100%" }}
                            placeholder=""
                            showTime={true}
                          // disabled={true}
                          ></DatePicker>
                        </Col>
                        <Col span={6}>
                          <div className="Label" style={{ marginBottom: 5 }}>
                            Тендерийн урилга нийтлэх огноо
                          </div>
                          <DatePicker
                            defaultValue={
                              this.state.publishdate
                                ? moment(this.state.publishdate, "YYYY.MM.DD")
                                : null
                            }
                            onChange={this.onChangePublishDate}
                            format="YYYY.MM.DD"
                            size="middle"
                            style={{ width: "100%" }}
                            placeholder=""
                          // disabled={true}
                          ></DatePicker>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 30 }} gutter={(16, 16)}>
                        <Col span={24}>
                          <div className="Label" style={{ marginBottom: 5 }}>
                            Дэлгэрэнгүй тайлбар
                          </div>
                          <TextArea
                            // disabled={true}
                            rows={6}
                            defaultValue={this.state.description}
                            onChange={this.onChangeDescription}
                          />
                        </Col>
                      </Row>
                    </div>
                    {this.state.status === 7 || this.state.status === 8 || this.state.status === 9 ?
                      <Row justify="start" align="middle">
                        {/* <Col>
                          {this.context.permission.isReopen === 1 ?
                          <Popover
                            placement="bottomRight"
                            title="Санамж"
                            content={this.popConfirmRePublishRequest}
                            trigger="click"
                            visible={this.state.popConfirmRePublishReqVisible}
                          >
                            <Button
                              type="primary"
                              style={{
                                backgroundColor: "#0358A7",
                                borderRadius: 4,
                                marginTop: 20,
                              }}
                              htmlType="submit"
                              onClick={() => this.onChangePopConfirmRePublishReqVisible(true)}
                              disabled={this.state.status === 9 ? true : false}
                            >
                              Дахин зарлах хүсэлт
                            </Button>
                          </Popover>
                          : null}
                        </Col> */}
                        {/* <Col>
                          {this.context.permission.isReopen === 1 ?
                          <Popover
                            placement="bottomRight"
                            title="Санамж"
                            content={this.popConfirmRePublish}
                            trigger="click"
                            visible={this.state.popConfirmRePublishVisible}
                          >
                            <Button
                              type="primary"
                              style={{
                                backgroundColor: "#0358A7",
                                borderRadius: 4,
                                marginTop: 20,
                                marginLeft: 10
                              }}
                              htmlType="submit"
                              onClick={() => this.onChangePopConfirmRePublishVisible(true)}
                              disabled={this.state.status === 9 ? false : true}
                            >
                              Дахин зарлах
                            </Button>
                          </Popover>
                          : null}
                        </Col> */}
                      </Row> :
                      <Row justify="start" align="middle">
                        {this.state.status === 0 ?
                          <Col>
                            <Button
                              type="default"
                              style={{
                                fontWeight: 600,
                                fontSize: 14,
                                color: "#212121",
                                borderRadius: 2,
                                marginTop: 20,
                                marginRight: 10,
                              }}
                              onClick={this.onSaveInvitationAfterPublish}
                            >
                              Хадгалах
                            </Button>
                          </Col> : null}
                      </Row>
                    }
                    { this.context.permission.isAdmin === "1" ?
                    <Col>
                      <Popover
                        placement="bottomRight"
                        title="Санамж"
                        content={this.popConfirm}
                        trigger="click"
                        visible={this.state.popConfirmVisible}
                      >
                        <Button
                          type="primary"
                          className="btnPrimary"
                          style={{
                            marginRight: 10,
                          }}
                          disabled={
                            (this.state.status === 6 || this.state.status === 8) 
                              ? false
                              : true
                          }
                          htmlType="submit"
                          onClick={() => this.onChangePopConfirmVisible(true)}
                          icon={<ShareAltOutlined />}
                        >
                          Урилга нийтлэх
                        </Button>
                      </Popover>
                      <Button
                          type="primary"
                          className="btnPrimary"
                          style={{marginRight: 10,}}
                          htmlType="submit"
                          onClick={() => this.sendMassMail()}
                        >
                          Тендерийн тухай Мэдэгдэл имэйл илгээх
                        </Button>
                    </Col> : null} 
                    {this.state.delayedList.length > 0 ?
                      <div style={{ marginTop: 20, backgroundColor: "white" }} id="tender-list">
                        <div className="MidLabel" style={{ padding: 10 }}>Хойшлуулсан түүх</div>
                        <Table
                          dataSource={this.state.delayedList}
                          columns={[
                            {
                              title: "№",
                              dataIndex: "key",
                              key: "key",
                              width: "3%",
                              render: (text, row, index) => (
                                <>{this.state.delayedList.indexOf(row) + 1}</>
                              ),
                            },
                            ...delayedCols,
                          ]}
                          pagination={false}
                          rowKey="id"
                          scroll={{ y: 340 }}
                        />
                      </div> : 
                    null} 
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Invitation);
